import React, { Component } from "react";
import { connect } from "dva";
import moment from "moment";
import Copy from "react-copy-to-clipboard";
// eslint-disable-next-line import/no-extraneous-dependencies
import { router } from "umi";
import { stringify } from "qs";
import { Popconfirm, Tooltip, Badge, message, Icon } from "antd";
import Container from "../../../../components/Container";
import ListPage from "../../../../components/ListPage";
import OperateDropdown from "../../../../components/OperateDropdown";
import ListSearch from "../Components/ListSearch/index";
import { getComposeUrl } from "../../../../utils/common";
// import { copyTxt } from "../utils";
import TemplateModal from "../Components/TemplateModal";
import RobotModal from "../Components/RobotModal";
import DatePickerModal from "../Components/DatePickerModal";
import { GetQueryString } from "../../../../utils/utils";
import styles from "./index.less";

const { ListTable, ListCreate } = ListPage;

const statusIcon = {
  0: "warning",
  1: "processing",
  2: "default"
};
const statusText = {
  0: "草稿",
  1: "进行中",
  2: "已结束"
};

let appId = GetQueryString("appId") || 40;

@connect(({ activityList, activityGlobal, user, loading }) => {
  return {
    ...activityGlobal,
    ...activityList,
    currentUser: user.currentUser,
    loading: loading.effects["activityGlobal/fetchTemplateList"],
    pageLoading:
      loading.effects["activityGlobal/fetchReadProps"] ||
      loading.effects["activityGlobal/fetchEnd"]
  };
})
class ActivityList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      nowTypeId: 0,
      showRobotModal: false,
      nowActivityBizId: "",
      nowActivityOrgId: "",
      nowHaveRobot: false,
      showDatePickerModal: false,
      nowActivity: {}
    };
    appId = GetQueryString("appId") || 40;
  }

  componentDidMount() {
    const params = {
      page: 1,
      pageSize: 10
    };
    this.fetchTypeList();
    this.fetchStatusList();
    this.fetchActivityList(params);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "activityList/reset"
    });
  }

  // 获取活动列表
  fetchActivityList = params => {
    const { dispatch, pageInfo, queries } = this.props;
    dispatch({
      type: "activityList/fetchActivityList",
      params: { ...pageInfo, ...queries, ...params }
    });
  };

  // 获取状态列表
  fetchStatusList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "activityGlobal/fetchStatusList"
    });
  };

  // 获取活动类别列表
  fetchTypeList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "activityGlobal/fetchTypeList"
    });
  };

  handleReset = () => {
    const params = {
      page: 1,
      pageSize: 10,
      name: "",
      status: "",
      typeId: ""
    };
    this.fetchActivityList(params);
  };

  // 显示模板选择对话框
  handleShowModal = () => {
    this.handleGetTemplateData(0);
    this.setState({
      modalVisible: true
    });
  };

  // 关闭对话框
  handleCloseModal = () => {
    this.setState({
      modalVisible: false,
      nowTypeId: 0
    });
  };

  // 展示日期选择弹框
  handleShowDatePickerModal = record => {
    this.setState({
      showDatePickerModal: true,
      nowActivity: record
    });
  };

  // 关闭日期选择弹框
  handleCloseDatePickerModal = () => {
    this.setState({
      showDatePickerModal: false
    });
  };

  // 日期选择弹框确定的回调
  handleOkReadDate = (date, nowState) => {
    const stateMessage = {
      over: "打卡已结束",
      ago: "未开始打卡",
      after: "未到打卡日期"
    };
    if (nowState === "now") {
      this.handleGetReadProps(date);
    } else {
      message.error(stateMessage[nowState]);
    }
    this.handleCloseDatePickerModal();
  };

  // 获取阅读组件相关信息
  handleGetReadProps = date => {
    const { dispatch } = this.props;
    const { nowActivity } = this.state;
    const { activityBizId, orgId } = nowActivity;
    dispatch({
      type: "activityGlobal/fetchReadProps",
      params: {
        clockDate: date,
        activityBizId,
        activityOrgId: orgId
      },
      callback: this.handleJumpToReadDetail
    });
  };

  // 跳转阅读组件详情
  handleJumpToReadDetail = () => {
    const { newReadCompParams } = this.props;
    router.push(
      `${getComposeUrl("/activitySign/list/readDetail")}?${stringify({
        ...newReadCompParams,
        appId
      })}`
    );
  };

  // 获取模板数据
  handleGetTemplateData = typeId => {
    const { dispatch } = this.props;
    dispatch({
      type: "activityGlobal/fetchTemplateList",
      params: {
        typeId: typeId === 0 ? "" : typeId
      }
    });
  };

  // 修改当前模板的tab
  handleChangeTab = tabId => {
    this.handleGetTemplateData(tabId);
    this.setState({
      nowTypeId: tabId
    });
  };

  // 点击选中某个模板
  handleSelectTemplate = data => {
    router.push(
      `${getComposeUrl("/activitySign/list/create")}?${stringify({
        templateId: data.templateId,
        typeId: data.typeId,
        appId
      })}`
    );
  };

  // 编辑或者新建会议
  handleGoToCreateOrEdit = record => {
    if (record) {
      router.push(
        `${getComposeUrl("/activitySign/list/edit")}?activityBizId=${
          record.activityBizId
        }&activityOrgId=${record.orgId}&appId=${appId}`
      );
    } else {
      router.push(
        `${getComposeUrl("/activitySign/list/create")}?appId=${appId}`
      );
    }
  };

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const params = { page, pageSize };
    this.fetchActivityList(params);
  };

  // 删除
  handleDelete = activityBizId => {
    const { dispatch } = this.props;
    dispatch({
      type: "activityList/fetchDelete",
      params: {
        bizId: activityBizId
      },
      callback: this.fetchActivityList
    });
  };

  // 复制活动地址逻辑操作
  handleCopyAddr = (text, result) => {
    // if(copyTxt) {
    //   copyTxt('xxxxxxxxx')
    // }
    if (result) {
      message.success("复制成功");
    } else {
      message.error("复制失败，浏览器不支持");
    }
  };

  // 结束活动逻辑操作
  handleEndActivity = record => {
    const { dispatch } = this.props;
    const { activityBizId, orgId } = record;
    dispatch({
      type: "activityGlobal/fetchEnd",
      params: {
        bizId: activityBizId,
        orgId
      },
      callback: this.fetchActivityList
    });
  };

  // 设置机器人逻辑操作
  handleSetRobot = record => {
    const { activityBizId, orgId, robotFlag } = record;
    this.setState({
      nowActivityBizId: activityBizId,
      nowActivityOrgId: orgId,
      nowHaveRobot: robotFlag,
      showRobotModal: true
    });
  };

  // 关闭机器人的弹框
  handleCloseRobotModal = () => {
    this.setState({
      showRobotModal: false
    });
    this.fetchActivityList();
  };

  // 移除机器人逻辑操作
  handleRemoveRobot = record => {
    const { activityBizId, orgId } = record;
    const { dispatch } = this.props;
    dispatch({
      type: "signRobot/fetchDeleteRobot",
      params: {
        activityBizId,
        activityOrgId: orgId
      },
      callback: this.fetchActivityList
    });
  };

  setColumns = () => {
    const { currentUser } = this.props;
    const { orgType } = currentUser || {};
    const columns = [
      {
        title: "活动名称",
        dataIndex: "name",
        key: "name",
        width: 330,
        fixed: "left",
        render: (title, record) => (
          <>
            {record.bureauEducationFlag === 1 && orgType === "school" && (
              <span className="Bureau">
                <p>局</p>
              </span>
            )}
            <Tooltip placement="top" title={title}>
              <span>
                {title.length <= 20 ? title : `${title.substring(0, 12)}...`}
              </span>
            </Tooltip>
          </>
        )
      },
      {
        title: "发布人",
        dataIndex: "publisher",
        key: "publisher",
        width: 150,
        render: publisher => {
          if (publisher) {
            return (
              <Tooltip placement="top" title={publisher}>
                <span>
                  {publisher.length <= 8
                    ? publisher
                    : `${publisher.substring(0, 8)}...`}
                </span>
              </Tooltip>
            );
          }
          return "-";
        }
      },
      {
        title: "相同权限人",
        dataIndex: "sameAuthorityList",
        key: "sameAuthorityList",
        width: 120,
        render: sameAuthorityList => {
          if (sameAuthorityList && sameAuthorityList.length) {
            return (
              <Tooltip
                placement="top"
                title={sameAuthorityList.map(item => (
                  <span>{item} </span>
                ))}
              >
                <span>
                  {sameAuthorityList.length > 1
                    ? `${sameAuthorityList[0]}...`
                    : sameAuthorityList[0]}
                </span>
              </Tooltip>
            );
          }
          return (
            <Tooltip placement="top" title="-">
              <span>-</span>
            </Tooltip>
          );
        }
      },
      {
        title: "开始时间",
        dataIndex: "startDate",
        key: "startDate",
        render: startDate => {
          return startDate ? moment(startDate).format("YYYY.MM.DD HH:mm") : "-";
        }
      },
      {
        title: "结束时间",
        dataIndex: "endDate",
        key: "endDate",
        render: endDate => {
          return endDate ? moment(endDate).format("YYYY.MM.DD HH:mm") : "-";
        }
      },
      {
        title: "活动状态",
        dataIndex: "status",
        key: "status",
        width: 120,
        render: status => {
          return (
            <Badge status={statusIcon[status]} text={statusText[status]} />
          );
        }
      },
      {
        title: (
          <>
            活动人数
            <Tooltip
              placement="top"
              title="活动创建后，根据本次发布对象的范围，可能会有5～10分钟的初始化时间，初始化完成之前默认人数展示为0，请耐心等待"
              autoAdjustOverflow
              overlayStyle={{ maxWidth: 410 }}
            >
              <Icon type="question-circle" style={{ marginLeft: 4 }} />
            </Tooltip>
          </>
        ),
        dataIndex: "joinUserNum",
        key: "joinUserNum",
        width: 120
      },
      {
        title: "打卡明细",
        key: "activityBizId",
        width: 120,
        render: record => {
          const { status } = record;
          return status === 0 ? (
            "-"
          ) : (
            <span
              style={{ color: "#1785ec" }}
              onClick={() => this.handleShowDatePickerModal(record)}
            >
              查看
            </span>
          );
        }
      },
      {
        title: "操作",
        key: "action",
        width: 220,
        fixed: "right",
        render: record => {
          const { status } = record;
          const actionOfStatus = {
            0: this.renderGraftAction(record),
            1: this.renderOnGoingAction(record),
            2: this.renderFinishedAction(record)
          };
          if (record.bureauEducationFlag === 1 && orgType === "school") {
            return <span>-</span>;
          }
          return actionOfStatus[status];
        }
      }
    ];
    return columns;
  };

  // 编辑
  renderEditBtn = record => {
    return <a onClick={() => this.handleGoToCreateOrEdit(record)}>编辑</a>;
  };

  // 删除
  renderDelBtn = record => {
    return (
      <Popconfirm
        title="确认删除？"
        okText="确认"
        cancelText="取消"
        className="del"
        onConfirm={() => this.handleDelete(record.activityBizId)}
      >
        <a>删除</a>
      </Popconfirm>
    );
  };

  // 复制活动分享地址
  renderCopyBtn = record => {
    const { activityUrl } = record;
    return (
      <Copy text={activityUrl} onCopy={this.handleCopyAddr}>
        <a>复制活动分享地址</a>
      </Copy>
    );
  };

  // 结束活动
  renderEndActivity = record => {
    return (
      <Popconfirm
        title="结束活动后，将不能继续参加打卡，确定提前结束活动?"
        okText="确认"
        cancelText="取消"
        onConfirm={() => this.handleEndActivity(record)}
        overlayStyle={{ width: 240 }}
      >
        <a>结束活动</a>
      </Popconfirm>
    );
  };

  // 设置机器人
  renderRobotBtn = record => {
    return <a onClick={() => this.handleSetRobot(record)}>设置机器人</a>;
  };

  // 移除机器人
  renderRemoveRobot = record => {
    return (
      <Popconfirm
        title="确认移除机器人内容?"
        okText="确认"
        cancelText="取消"
        className="del"
        onConfirm={() => this.handleRemoveRobot(record)}
      >
        <a>移除机器人</a>
      </Popconfirm>
    );
  };

  // 已结束 状态下 操作
  renderFinishedAction = record => {
    const data = [
      {
        text: this.renderCopyBtn(record)
      },
      {
        text: this.renderDelBtn(record)
      },
      {
        text: this.renderRemoveRobot(record)
      }
    ];
    return <OperateDropdown data={data} />;
  };

  // 草稿 状态下 操作
  renderGraftAction = record => {
    const data = [
      {
        text: this.renderEditBtn(record)
      },
      {
        text: this.renderRobotBtn(record)
      },
      {
        text: this.renderDelBtn(record)
      }
    ];
    return <OperateDropdown data={data} />;
  };

  // 进行中 状态下 操作
  renderOnGoingAction = record => {
    const data = [
      {
        text: this.renderEditBtn(record)
      },
      {
        text: this.renderRobotBtn(record)
      },
      {
        text: this.renderCopyBtn(record)
      },
      {
        text: this.renderEndActivity(record)
      },
      {
        text: this.renderDelBtn(record)
      }
    ];
    return <OperateDropdown data={data} />;
  };

  render() {
    const {
      spinProps,
      pageInfo,
      activityList,
      typeList,
      statusList,
      templateList,
      loading,
      pageLoading
    } = this.props;
    const { spinning, tip } = spinProps;
    const {
      modalVisible,
      nowActivityBizId,
      nowActivityOrgId,
      showRobotModal,
      nowHaveRobot,
      nowTypeId,
      showDatePickerModal,
      nowActivity
    } = this.state;
    const modalProps = {
      visible: modalVisible,
      onCancel: this.handleCloseModal,
      title: "选择",
      footer: null,
      wrapClassName: "templateWrapper"
    };

    const pageProps = {
      spinProps: { spinning: spinning || pageLoading || false, tip },
      className: styles.root
    };

    const columns = this.setColumns();

    const tableProps = {
      pageInfo,
      columns,
      list: activityList,
      rowKey: "activityBizId",
      selfPageNation: pageInfo,
      onPageChange: this.handlePaginationChange
    };

    const searchProps = {
      fetchList: this.fetchActivityList,
      typeList,
      statusList,
      handleReset: this.handleReset
    };

    const createBtn = {
      btnText: " 新建活动",
      onCreate: this.handleShowModal
    };

    const robotModalProps = {
      nowActivityBizId,
      nowActivityOrgId,
      showRobotModal,
      nowHaveRobot,
      handleCloseRobotModal: this.handleCloseRobotModal
    };

    const datePickerModalProps = {
      visible: showDatePickerModal,
      onOk: this.handleOkReadDate,
      onCancel: this.handleCloseDatePickerModal,
      nowActivity
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <ListSearch {...searchProps} />
          <ListCreate {...createBtn} />
          <ListTable {...tableProps} />
        </ListPage>
        {modalVisible && (
          <TemplateModal
            modalProps={modalProps}
            handleSelectTemplate={this.handleSelectTemplate}
            nowTypeId={nowTypeId}
            handleChangeTab={this.handleChangeTab}
            loading={loading}
            templateList={templateList}
            typeList={typeList}
          />
        )}
        {showRobotModal && <RobotModal {...robotModalProps} />}
        {showDatePickerModal && <DatePickerModal {...datePickerModalProps} />}
      </Container>
    );
  }
}

export default ActivityList;
